import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** The dialog body: what rotating does, one line per consequence. */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** A consequence line: it explains the title's question, so muted, like the delete dialog's. */
export const Line = styled(Text)`
  display: block;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;
